import React, { Component } from 'react';
import { Link } from 'react-router';

import GuideButton from '../GuideButton';
export default class GuideSectionCallouts extends Component {

  render() {
    const { slugTo } = this.props;
    return (
      <div className="GuideSectionCallouts">
        <div className="col-3">
          <Link to="guide-to-gardening/part-one-introduction">
            <div className="GuideSectionCallouts__image GuideSectionCallouts__image--one" />
          </Link>
          <h3>Part I: Preparing Your Grow</h3>
          <p>Set up your grow, and learn what it takes to grow marijuana.</p>
          <GuideButton slugTo="part-one-introduction" cta="View Part I" />
        </div>
        <div className="col-3">
          <Link to="guide-to-gardening/part-two-introduction">
            <div className="GuideSectionCallouts__image GuideSectionCallouts__image--two" />
          </Link>
          <h3>Part II: The Grow Process</h3>
          <p>Dive into each step of the grow process from seed to harvest.</p>
          <GuideButton slugTo="part-two-introduction" cta="View Part II" />
        </div>
        <div className="col-3">
          <Link to="guide-to-gardening/part-three-introduction">
            <div className="GuideSectionCallouts__image GuideSectionCallouts__image--three" />
          </Link>
          <h3>Part III: Taking It Further</h3>
          <p>Optimize your grow and learn how to  maximize your yield.</p>
          <GuideButton slugTo="part-three-introduction" cta="View Part III" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/GuideSectionCallouts/GuideSectionCallouts.js